// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"play-chart"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 3H21M11.5 17.5L7 22M12.5 17.5L17 22M20 3V17H4V3H20Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M8 9.66667V13M12 7V13M16 11V13","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const PlayChartIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'play-chart',
    ref,
    icon: element,
  },
));

PlayChartIcon.displayName = 'PlayChartIcon';

export default PlayChartIcon;
